export enum NotificationOrigin {
    PurchaseOrderManual = 'PURCHASE_ORDER_TYPE_MANUAL',
    PurchaseOrderShop = 'PURCHASE_ORDER_TYPE_SHOP',
    Invoice = 'INVOICE',
    Inquiry = 'INQUIRY',
    Demand = 'DEMAND',
    Import = 'IMPORT',
}

export const getNotificationOriginTranslationId = (orderType: NotificationOrigin) => {
    return `app.enum.notificationOrigin.${orderType}`;
};
